module.exports = __webpack_public_path__ + "img/social-media-profiles.ec372dbd.svg";